export default __webpack_public_path__ + "static/honestbee_2-5b335b578549e5dd1c2180c65c93745b.jpg";